module.exports = __webpack_public_path__ + "static/media/system-user.e613ef44.svg";